import authService from './authService';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();

export interface PermissionItem {
  key: string;
  label: string;
  granted: boolean;
}

export interface MyPermissionsResponse {
  data: {
    permissions: string[];
    allPermissions: PermissionItem[];
  };
}

export interface PharmacyStaffMember {
  _id: string;
  fullName: string;
  email: string;
  staffRole: string;
  pharmacyPermissions: string[];
  monthlyGrossSalary?: number | null;
  isAdmin: boolean;
  permissionLabels: PermissionItem[];
}

async function getAuthHeaders(): Promise<HeadersInit> {
  const token = authService.getAccessToken();
  if (!token) throw new Error('Session expired. Please login again.');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'X-Device-ID': authService.getDeviceId(),
  };
}

export const pharmacyPermissionsService = {
  async getMyPermissions(): Promise<MyPermissionsResponse> {
    const res = await fetch(`${API_BASE_URL}/api/V0/Pharmacy/Permissions/me`, {
      headers: await getAuthHeaders(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.message || 'Failed to load permissions');
    return data;
  },

  async listStaff(): Promise<{ data: PharmacyStaffMember[] }> {
    const res = await fetch(`${API_BASE_URL}/api/V0/Pharmacy/Permissions/staff`, {
      headers: await getAuthHeaders(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.message || 'Failed to load staff');
    return data;
  },

  async updateStaffPermissions(staffId: string, permissions: string[]): Promise<void> {
    const res = await fetch(`${API_BASE_URL}/api/V0/Pharmacy/Permissions/staff/${staffId}`, {
      method: 'PUT',
      headers: await getAuthHeaders(),
      body: JSON.stringify({ permissions }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.message || 'Failed to update permissions');
  },
};

export default pharmacyPermissionsService;
